module.exports = __webpack_public_path__ + "static/logo-mato-njavro-a65c34b923fd909a9eb417cb91b10669.svg";